export default __webpack_public_path__ + "3b9000f0097a2cc2830533d2afd4fd48.png";